import { App } from 'vue';
import SvgIcon from './index.vue';

// 加载 svg 文件
const requireAll = (requireContext: __WebpackModuleApi.RequireContext) => requireContext.keys().map(requireContext);
const svgIcons = require.context('@/assets/icons', false, /\.svg$/);
requireAll(svgIcons);

// Export a function to register the component globally
export function registerSvgIcon(app: App) {
  app.component('SvgIcon', SvgIcon);
}
